import { render, staticRenderFns } from "./odemesekillericomp.vue?vue&type=template&id=2e610af3&"
import script from "./odemesekillericomp.vue?vue&type=script&lang=js&"
export * from "./odemesekillericomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports